import { EvaluationStatusFilter, IEvaluatorProjects, INotificationHistory, IProjectEvaluationListData, IProjectEvaluatorData } from "..";
import { requestLaravel } from "../../../../utils/api";
import { ApiResponse, IDashboardFilterData } from "../../core/_models";


interface IProjectEvaluationResp{
    page: number;
    page_size: number;
    total_filtered_projects: number;
    total_pages: number;
    projects: IProjectEvaluationListData[]
}
export function getEvaluationProjectsList({
    filters,
    search = '',
    eval_status_filter = EvaluationStatusFilter.all,
    page = 1,
    signal,
}: {
    filters: IDashboardFilterData
    search?: string
    eval_status_filter?: string
    page?: number
    signal?: AbortSignal
}) {
    return requestLaravel<ApiResponse<IProjectEvaluationResp>>('/projects/get-evaluation-projects', {
        eval_status_filter,
        search,
        page,
        ...filters,
    }, { signal });
}

interface IProjectEvaluationCountsResp{
    total_completed:number;
    total_evaluation_projects:number;
    total_overdue:number;
    total_pending:number;
    total_await_sign_off:number;
    can_manage_evaluation_reminders?: boolean;
}
export function getEvaluationProjectCounts(signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProjectEvaluationCountsResp>>(
        '/projects/get-evaluation-project-counts',
        {},
        { signal }
    );
}

interface IProjectEvaluatorResp{
    page: number;
    page_size: number;
    total_filtered_evaluators: number;
    total_pages: number;
    evaluators: IProjectEvaluatorData[]
}
export function getEvaluationEvaluatorsList({ search='', eval_status_filter=EvaluationStatusFilter.all, page=1, signal }: {
    search?: string
    eval_status_filter?: string
    page?: number
    signal?: AbortSignal
}) {
    return requestLaravel<ApiResponse<IProjectEvaluatorResp>>(
        '/projects/get-project-evaluators',
        { eval_status_filter: eval_status_filter, search: search, page: page },
        { signal }
    );
}

export function getEvaluatorProjects({ evaluator_id, eval_status_filter='' }: {
    evaluator_id: number;
    eval_status_filter?: string;
}) {
    return requestLaravel<ApiResponse<IEvaluatorProjects[]>>('/projects/get-evaluator-projects-list', { evaluator_id: evaluator_id, eval_status_filter: eval_status_filter });
}
export function sendEvaluationReminderEmails({ evaluator_id, project_ids }: {
    evaluator_id: number;
    project_ids: number[];
}) {
    return requestLaravel<ApiResponse<{evaluator_id:number,project_ids:number[],project_count:number}>>('/projects/send-evaluation-reminder-emails', { evaluator_id: evaluator_id, project_ids: project_ids });
}
export function sendEvaluationReminderEmailsToAllEvaluators({ project_id, evaluator_ids }: {
    project_id: number;
    evaluator_ids: number[];
}) {
    return requestLaravel<ApiResponse<{evaluator_count:number,evaluator_ids:number[]}>>('/projects/send-evaluation-reminder-emails-to-all-evaluators', { project_id: project_id, evaluator_ids: evaluator_ids });
}

export function getEvaluatorReminderHistory({ project_id }: {
    project_id: number;
}) {
    return requestLaravel<ApiResponse<INotificationHistory[]>>('/projects/get-evaluator-reminder-history', { project_id: project_id });
}